import React, { useState } from 'react';
import { Plus, Trash2 } from 'lucide-react';
import { Button } from './ui/button';
import { Label } from './ui/label';

export interface HorarioRango {
  inicio: string;
  fin: string;
}

export interface TiemposDisponibles {
  lunes: HorarioRango[];
  martes: HorarioRango[];
  miercoles: HorarioRango[];
  jueves: HorarioRango[];
  viernes: HorarioRango[];
  sabado: HorarioRango[];
  domingo: HorarioRango[];
}

interface AvailabilitySchedulerProps {
  value: TiemposDisponibles | null;
  onChange: (value: TiemposDisponibles) => void;
}

const DIAS_SEMANA = [
  { key: 'lunes', label: 'Lunes' },
  { key: 'martes', label: 'Martes' },
  { key: 'miercoles', label: 'Miércoles' },
  { key: 'jueves', label: 'Jueves' },
  { key: 'viernes', label: 'Viernes' },
  { key: 'sabado', label: 'Sábado' },
  { key: 'domingo', label: 'Domingo' },
] as const;

const initialSchedule: TiemposDisponibles = {
  lunes: [],
  martes: [],
  miercoles: [],
  jueves: [],
  viernes: [],
  sabado: [],
  domingo: [],
};

export const AvailabilityScheduler: React.FC<AvailabilitySchedulerProps> = ({
  value,
  onChange,
}) => {
  const schedule = value || initialSchedule;

  const addTimeSlot = (dia: keyof TiemposDisponibles) => {
    const newSchedule = {
      ...schedule,
      [dia]: [...schedule[dia], { inicio: '08:00', fin: '14:00' }],
    };
    onChange(newSchedule);
  };

  const removeTimeSlot = (dia: keyof TiemposDisponibles, index: number) => {
    const newSchedule = {
      ...schedule,
      [dia]: schedule[dia].filter((_, i) => i !== index),
    };
    onChange(newSchedule);
  };

  const updateTimeSlot = (
    dia: keyof TiemposDisponibles,
    index: number,
    field: 'inicio' | 'fin',
    value: string
  ) => {
    const newSchedule = {
      ...schedule,
      [dia]: schedule[dia].map((slot, i) =>
        i === index ? { ...slot, [field]: value } : slot
      ),
    };
    onChange(newSchedule);
  };

  return (
    <div className="space-y-4">
      <div className="border rounded-lg overflow-hidden">
        {DIAS_SEMANA.map(({ key, label }) => (
          <div key={key} className="border-b last:border-b-0">
            <div className="p-4 bg-gray-50">
              <div className="flex items-center justify-between">
                <Label className="font-medium text-gray-700">{label}</Label>
                <Button
                  type="button"
                  onClick={() => addTimeSlot(key)}
                  size="sm"
                  variant="outline"
                  className="h-8 px-3"
                >
                  <Plus className="h-4 w-4 mr-1" />
                  Agregar Horario
                </Button>
              </div>

              {schedule[key].length > 0 ? (
                <div className="mt-3 space-y-2">
                  {schedule[key].map((slot, index) => (
                    <div
                      key={index}
                      className="flex items-center gap-2 bg-white p-2 rounded border"
                    >
                      <div className="flex items-center gap-2 flex-1">
                        <div className="flex-1">
                          <input
                            type="time"
                            value={slot.inicio}
                            onChange={(e) =>
                              updateTimeSlot(key, index, 'inicio', e.target.value)
                            }
                            className="w-full px-2 py-1 border border-gray-300 rounded text-sm"
                          />
                        </div>
                        <span className="text-gray-500">-</span>
                        <div className="flex-1">
                          <input
                            type="time"
                            value={slot.fin}
                            onChange={(e) =>
                              updateTimeSlot(key, index, 'fin', e.target.value)
                            }
                            className="w-full px-2 py-1 border border-gray-300 rounded text-sm"
                          />
                        </div>
                      </div>
                      <button
                        type="button"
                        onClick={() => removeTimeSlot(key, index)}
                        className="text-red-600 hover:text-red-800 p-1"
                      >
                        <Trash2 className="h-4 w-4" />
                      </button>
                    </div>
                  ))}
                </div>
              ) : (
                <p className="text-sm text-gray-400 mt-2">No disponible</p>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
